export default __webpack_public_path__ + "static/media/Sad.e5f8bb3b.png";